const COMPANY_SCOPED_LISTS = [
    { prefix: "/works", listPath: "/works" },
    { prefix: "/beneficiars", listPath: "/beneficiars" },
] as const;

/**
 * Detail routes keep an id that belongs to the company you are leaving.
 * Returns the list path to open instead, or null when the current path can be reloaded as-is.
 */
export const locationAfterCompanySwitch = (pathname: string): string | null => {
    for (const route of COMPANY_SCOPED_LISTS) {
        if (pathname === route.prefix) return null;
        if (pathname.startsWith(`${route.prefix}/`)) return route.listPath;
    }

    // Contract flow (`/work/:id/...`), distinct from the `/works` list.
    if (pathname.startsWith("/work/")) return "/works";

    return null;
};

export const reloadAfterCompanySwitch = () => {
    const nextPath = locationAfterCompanySwitch(window.location.pathname);
    if (nextPath == null) {
        window.location.reload();
        return;
    }
    // Replace so Back does not reopen the previous company's detail url.
    window.location.replace(nextPath);
};
